var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4859 18.5001C20.4859 23.1945 16.5715 27 11.7431 27C6.91469 27 3 23.1936 3 18.5001C3 13.8067 6.91439 10 11.7431 10C16.5718 10 20.4859 13.8058 20.4859 18.5001ZM30.077 18.5001C30.077 22.9189 28.1198 26.5024 25.7055 26.5024C23.2911 26.5024 21.3339 22.9189 21.3339 18.5001C21.3339 14.0814 23.2908 10.4979 25.7052 10.4979C28.1195 10.4979 30.0767 14.0803 30.0767 18.5001H30.077ZM34 18.5001C34 22.4582 33.3118 25.6689 32.4625 25.6689C31.6133 25.6689 30.9253 22.4591 30.9253 18.5001C30.9253 14.5412 31.6136 11.3314 32.4625 11.3314C33.3115 11.3314 34 14.5409 34 18.5001Z",
    fill: "#8ABE84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.20f1a7d3a4675acf6b0d31a19296eea9.svg";
export { ForwardRef as ReactComponent };